<div class="bottom-menu" [ngClass]="[this.genericController.active? 'active' : '', genericController.fullScreenMode ? 'fullscreen' : '', menuController.open ? 'open-menu': '']">
  <div class="fields">
    <!-- <h2>{{ this.genericController.windowName}}</h2> -->
    <div class="close" (click)="cancelWindow()">
      <img src="/assets/img/close-white.svg" alt="" />
    </div>
    <div class="fullscreen-btn" (click)="genericController.fullScreenMode = !genericController.fullScreenMode"></div>

    <app-tabs></app-tabs>
    <div class="fields__container">
    </div>
  </div>
</div>
